import React from "react";
import BannerProduct from "../components/GreenHome/BannerProduct";
import AboutSection from "../components/GreenHome/AboutSection";
import SectionProjectDetails from "../components/GreenHome/SectionProjectDetails";
import ApartmentsSection from "../components/GreenHome/ApartmentsSection";
import PhotoGallery from "../components/PhotoGallery";
import ProjectWhySection from "../components/GreenHome/ProjectWhySection/ProjectWhySection";
import SearchSection from "../components/GreenHome/SearchSection";

const GreenHome = () => {
  return (
    <div className="relative">
      <BannerProduct />
      <AboutSection />
      <SectionProjectDetails />
      <ApartmentsSection />
      <PhotoGallery project="greenHome" />
      <ProjectWhySection />
      <SearchSection project={"greenhome"} />
    </div>
  );
};

export default GreenHome;
